import { memo, type PropsWithChildren } from 'react';

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger
} from '@/shadcn/hover-card';

type Props = PropsWithChildren<{
  title?: React.ReactNode;
  body: React.ReactNode;
  delay?: number;
}>;

export const TooltipWrapper = memo(
  ({ children, title, body, delay }: Props) => (
    <HoverCard openDelay={delay}>
      <HoverCardTrigger className="size-full" data-testid="tooltip-wrapper">
        {children}
      </HoverCardTrigger>
      <HoverCardContent className="min-w-[60px] max-w-[440px] px-5 py-2.5">
        {title && (
          <div className="mb-1 border-border border-b font-semibold text-sm">
            {title}
          </div>
        )}
        <div className="text-justify text-[13px]">{body}</div>
      </HoverCardContent>
    </HoverCard>
  )
);
